export function Type(type : any) {
    return (target : any, propertyKey : string) => {
        Reflect.defineMetadata('design:arrayType', type, target, propertyKey);
    }
}